export const paginateItems = (items = [], requestedPage = 1, pageSize = 12) => {
  const values = Array.isArray(items) ? items : [];
  const size = Math.max(1, Number(pageSize) || 1);
  const pages = Math.max(1, Math.ceil(values.length / size));
  const page = Math.min(pages, Math.max(1, Number(requestedPage) || 1));
  const start = (page - 1) * size;

  return {
    items: values.slice(start, start + size),
    page,
    pages,
    total: values.length,
  };
};
